// extracted by mini-css-extract-plugin
export default {"main":"Result_main__7D77f"};